import type { DrawerPopupProps } from '@base-ui/react';

import { Drawer as BaseDrawer } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { backdropStyle, popupStyle, viewportStyle } from './Drawer.css';

type Props = DrawerPopupProps;

export const DrawerPopup = ({ children, ...delegated }: Props) => {
  return (
    <BaseDrawer.Portal>
      <BaseDrawer.Backdrop className={backdropStyle} />

      <BaseDrawer.Viewport className={viewportStyle}>
        <BaseDrawer.Popup {...delegated} className={clsxs(popupStyle, delegated.className)}>
          {children}
        </BaseDrawer.Popup>
      </BaseDrawer.Viewport>
    </BaseDrawer.Portal>
  );
};
